import {useState} from 'react'
import {getCamp} from '../services'
import {CampModel, SelectModel} from '../model'

const useCampListService = () => {
  const [loading, setLoading] = useState(false)
  const [campList, setCampList] = useState<SelectModel[]>([])
  const getCampService = async (campParams: CampModel) => {
    let obj: CampModel = {
      isCombo: true,
      ...campParams,
    }
    return await getCamp(obj, 1)
  }
  const getCampData = async (campParams: CampModel) => {
    setLoading(true)
    try {
      const response = await getCampService(campParams)
      return response.data.data
    } catch (error) {
      console.error('Error fetching client data:', error)
      throw error
    } finally {
      setLoading(false)
    }
  }
  const getCampFD = async (campParams: CampModel) => {
    setLoading(true)
    try {
      const data = await getCampData(campParams)
      const mappedSites = mapCampList(data)
      return mappedSites
    } catch (error) {
      console.error('Error fetching client data:', error)
      throw error
    } finally {
      setLoading(false)
    }
  }
  const mapCampList = (data: any[]) => {
    return data.map((item) => ({value: item.id, label: item.nombre}))
  }

  const updatecampList = (mappedSites: {value: string; label: string}[]) => {
    setCampList(mappedSites)
  }

  const getCampList = async (campParams: CampModel = {}) => {
    try {
      const data = await getCampData(campParams)
      const mappedSites = mapCampList(data)
      updatecampList(mappedSites)
    } catch (error) {
      console.error('Error fetching client data:', error)
    }
  }
  const handleClear = () => {
    setCampList([])
  }
  return {
    loading,
    campList,
    getCampList,
    getCampService,
    getCampFD,
    handleClear,
  }
}

export default useCampListService
